document.addEventListener("DOMContentLoaded", function () {
  const filterCheckboxes = document.querySelectorAll('input[name="filter"]');
  const applyFilterBtn = document.getElementById("apply-filter");
  const clearFilterBtn = document.getElementById("clear-filter");
  const filterCountSpan = document.getElementById("filter-count");
  const blogPostsGrid = document.getElementById("blog-posts-grid");
  const blogPostItems = document.querySelectorAll(".blog-post-item");

  /** @type {string[]} */
  let selectedFilters = [];

  // Update filter count and button states
  function updateFilterUI() {
    const count = selectedFilters.length;
    if (filterCountSpan) {
      filterCountSpan.textContent = count.toString();
    }

    if (count > 0) {
      if (clearFilterBtn && clearFilterBtn instanceof HTMLButtonElement) {
        clearFilterBtn.disabled = false;
      }
      if (applyFilterBtn) {
        applyFilterBtn.textContent = `Apply Filter (${count})`;
      }
    } else {
      if (clearFilterBtn && clearFilterBtn instanceof HTMLButtonElement) {
        clearFilterBtn.disabled = true;
      }
      if (applyFilterBtn) {
        applyFilterBtn.textContent = "Apply Filter (0)";
      }
    }
  }

  // Filter blog posts based on selected tags
  function filterBlogPosts() {
    // Show loading state
    showLoadingState();

    // Add a small delay to make the loading visible
    setTimeout(() => {
      let visibleCount = 0;

      blogPostItems.forEach((item) => {
        const dataTags = item.getAttribute("data-tags");
        if (!dataTags) return;

        const itemTags = dataTags.split(",").map((tag) => tag.trim());

        if (selectedFilters.length === 0) {
          // Show all posts if no filters selected
          if (item instanceof HTMLElement) {
            item.style.display = "block";
            item.style.opacity = "1";
            item.style.transform = "scale(1)";
            visibleCount++;
          }
        } else {
          // Show post if it has any of the selected tags
          const hasMatchingTag = selectedFilters.some((filter) =>
            itemTags.includes(filter)
          );
          if (item instanceof HTMLElement) {
            if (hasMatchingTag) {
              item.style.display = "block";
              item.style.opacity = "1";
              item.style.transform = "scale(1)";
              visibleCount++;
            } else {
              item.style.opacity = "0";
              item.style.transform = "scale(0.95)";
              setTimeout(() => {
                if (item instanceof HTMLElement) {
                  item.style.display = "none";
                }
              }, 150);
            }
          }
        }
      });

      // Hide loading
      hideLoadingState();
    }, 300); // 300ms delay to show loading
  }

  // Show loading spinner
  function showLoadingState() {
    if (blogPostsGrid) {
      blogPostsGrid.style.opacity = "0.6";
      blogPostsGrid.style.pointerEvents = "none";
    }

    // Add loading spinner if it doesn't exist
    if (!document.getElementById("filter-loading")) {
      const loadingSpinner = document.createElement("div");
      loadingSpinner.id = "filter-loading";
      loadingSpinner.innerHTML = `
        <div style="
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: white;
          padding: 20px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          z-index: 1000;
          display: flex;
          align-items: center;
          gap: 12px;
        ">
          <div style="
            width: 20px;
            height: 20px;
            border: 2px solid #f3f3f3;
            border-top: 2px solid #28a745;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          "></div>
          <span style="color: #495057; font-weight: 500;">Filtering posts...</span>
        </div>
        <style>
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        </style>
      `;
      document.body.appendChild(loadingSpinner);
    }
  }

  // Hide loading spinner
  function hideLoadingState() {
    if (blogPostsGrid) {
      blogPostsGrid.style.opacity = "1";
      blogPostsGrid.style.pointerEvents = "auto";
    }

    const loadingSpinner = document.getElementById("filter-loading");
    if (loadingSpinner) {
      loadingSpinner.remove();
    }
  }

  // Handle checkbox changes
  filterCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", function () {
      const tagValue = this.value;

      if (this.checked) {
        if (!selectedFilters.includes(tagValue)) {
          selectedFilters.push(tagValue);
        }
      } else {
        selectedFilters = selectedFilters.filter(
          (filter) => filter !== tagValue
        );
      }

      updateFilterUI();
    });
  });

  // Handle apply filter button
  if (applyFilterBtn) {
    applyFilterBtn.addEventListener("click", function () {
      filterBlogPosts();
    });
  }

  // Handle clear filter button
  if (clearFilterBtn) {
    clearFilterBtn.addEventListener("click", function () {
      // Uncheck all checkboxes
      filterCheckboxes.forEach((checkbox) => {
        if (checkbox instanceof HTMLInputElement) {
          checkbox.checked = false;
        }
      });

      // Clear selected filters
      selectedFilters = [];

      // Update UI
      updateFilterUI();

      // Show all posts
      filterBlogPosts();
    });
  }

  // Initialize UI
  updateFilterUI();
});
